export default (i: number) => {
  return (i * 0.000621371192).toFixed(1);
};
